import creations from './identificador/creations'
import apiKeys from './api_keys/creations'
import agentes from './agentes/creations'
import access from './access'

export default [...creations, ...apiKeys, ...agentes, ...access]
